import { QuestionCircleOutlined } from '@ant-design/icons'
import { Button, Collapse, Drawer } from 'antd'
import { FC, useState } from 'react'
import { helpItemsForm } from './help-items-form'

const HelpDrawerForm: FC = () => {
    const [open, setOpen] = useState(false)

    return (
        <>
            <Button type={'text'} icon={<QuestionCircleOutlined />} onClick={() => setOpen(true)}>
                Помощь
            </Button>

            <Drawer title={'Помощь'} width={1000} open={open} onClose={() => setOpen(false)}>
                <Collapse items={helpItemsForm} ghost />
            </Drawer>
        </>
    )
}

export default HelpDrawerForm
